import Swiper from 'swiper'
import size from './size'
import $ from 'jquery'

export const projectsSlider = () => {
  const sliderElement = document.querySelector('.projects-slider')

  if (!sliderElement) return

  let slidesPerView = size.isMobile() ? 'auto' : 4

  new Swiper('.projects-slider', {
    slidesPerView,
    spaceBetween: 12,
    pagination: {
      clickable: true,
    },
    navigation: {
      prevEl: '.special-projects .swiper-button-next',
      nextEl: '.special-projects .swiper-button-prev',
    },
  })
}

export const heroSlider = () => {

  const sliderElement = document.querySelector('.hero-slider')

  if (!sliderElement) return

  if (size.isMobile()) {
    // remove desktop slides
    $('.hero-slider__inner--desktop').remove()

  } else {
    // remove mobile slides
    $('.hero-slider__inner--mobile').remove()
  }

  new Swiper('.hero-slider', {
    //slidesPerView: 1,
    spaceBetween: 30,
    effect: 'fade',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
  }
  )
}